module.exports = __webpack_public_path__ + "img/wine1.d6135f97.jpg";